import { useState } from "react";
import Container from "Components/Container/Container";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import "./BrandStyle.css";
import { Link } from "react-router-dom";

const Brands = ({ data }) => {
  // State to track hovered brand
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section className="py-secondary lg:py-primary relative scroll-section flex items-center justify-center">
      <Container>
        <div className="mb-10">
          <h3 className="title text-center">BRANDS</h3>
        </div>

        <Swiper
          className="partnerSwipper"
          spaceBetween={20}
          slidesPerView={1}
          navigation={{ clickable: true }}
          speed={1000}
          pagination={{ clickable: true }}
          modules={[Pagination, Navigation]}
          breakpoints={{
            578: { slidesPerView: 3, slidesPerGroup: 4 },
            768: { slidesPerView: 5, slidesPerGroup: 5 },
          }}
        >
          {data?.map(({ logo, slug, logo_black }, index) => (
            <SwiperSlide key={index} className="flex items-center">
              <Link
                to={`/products/${slug}`}
                state={{ isBrand: true }}
                className="flex-1"
              >
                <div
                  className="h-full w-[70%] mx-auto transition-all duration-300"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <img
                    src={hoveredIndex === index ? logo : logo_black}
                    alt=""
                    className="h-full w-full object-contain transition-all duration-300"
                  />
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default Brands;
